module.exports = __webpack_public_path__ + "static/media/pressure.8dab1758.svg";